import { useEffect, useState } from 'react'
import { RiComputerLine, RiFacebookLine, RiInstagramLine, RiYoutubeLine, RiMailOpenLine, RiPhoneLine } from 'react-icons/ri'

import { ORGANIZATION_PHONES, ORGANIZATION_LINKS, ORGANIZATION_EMAILS } from '../../../../Utilities/APIs'


function OrganizationContacts({organizationId, consumer}) {

    const [phones, setPhones] = useState(null)
    const [emails, setEmails] = useState(null)
    const [links, setLinks] = useState(null)

    useEffect(() => {
        const getAndSetPhones = () => {
            fetch(ORGANIZATION_PHONES + 'getPhonesFromOrganization/' + organizationId)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(
                            `HTTP error - status: ${res.status}`
                        )
                    }
                    return res.json()
                })
                .then((data) => {
                    setPhones(data)
                })
        }
        getAndSetPhones()

        const getAndSetEmails = () => {
            fetch(ORGANIZATION_EMAILS + 'getEmailsFromOrganization/' + organizationId)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(
                            `HTTP error - status: ${res.status}`
                        )
                    }
                    return res.json()
                })
                .then((data) => {
                    setEmails(data)
                })
        }
        getAndSetEmails();

        const getAndSetLinks = () => {
            fetch(ORGANIZATION_LINKS + 'getLinksFromOrganization/' + organizationId)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(
                            `HTTP error - status: ${res.status}`
                        )
                    }
                    return res.json()
                })
                .then((data) => {
                    setLinks(data)
                })
        }
        getAndSetLinks();

    }, [organizationId])

    return (
        <div className="col right">
            <div className="contacts">
                <div className="list_item">
                    <div className="icon">
                        <RiPhoneLine />
                    </div>
                    <div className="content">
                        <h6>
                            {
                                consumer
                                ?
                                    consumer.language === 'english'
                                    ?
                                        'Hotline'
                                    :
                                        'হটলাইন'
                                :
                                    'হটলাইন'
                            }
                        </h6>
                        {phones?.map(phone => (
                            <a href={`tel:${phone.phone}`} key={phone._id}>{phone.phone}</a>
                        ))}
                    </div>
                </div>
                <div className="list_item">
                    <div className="icon">
                        <RiMailOpenLine />
                    </div>
                    <div className="content">
                        <h6>
                            {
                                consumer
                                ?
                                    consumer.language === 'english'
                                    ?
                                        'Email'
                                    :
                                        'ইমেইল'
                                :
                                    'ইমেইল'
                            }
                        </h6>
                        {emails?.map(email => (
                            <a href={`mailto:${email.email}`} key={email._id}>{email.email}</a>
                        ))}
                    </div>
                </div>

                {links?.find(l => l.name === 'website') &&
                    <div className="list_item">
                        <div className="icon">
                            <RiComputerLine />
                        </div>
                        <div className="content">
                            <h6>
                                {
                                    consumer
                                    ?
                                        consumer.language === 'english'
                                        ?
                                            'Website'
                                        :
                                            'ওয়েবসাইট'
                                    :
                                        'ওয়েবসাইট'
                                }
                            </h6>
                            <a href={links.find(l => l.name === 'website').link}>{links.find(l => l.name === 'website').link}</a>
                        </div>
                    </div>
                }
                {links?.find(l => l.name === 'facebook') &&
                    <div className="list_item">
                        <div className="icon">
                            <RiFacebookLine />
                        </div>
                        <div className="content">
                            <h6>
                                {
                                    consumer
                                    ?
                                        consumer.language === 'english'
                                        ?
                                            'Facebook'
                                        :
                                            'ফেসবুক'
                                    :
                                        'ফেসবুক'
                                }
                            </h6>
                            <a href={links.find(l => l.name === 'facebook').link}>{links.find(l => l.name === 'facebook').link}</a>
                        </div>
                    </div>
                }
                {links?.find(l => l.name === 'instagram') &&
                    <div className="list_item">
                        <div className="icon">
                            <RiInstagramLine />
                        </div>
                        <div className="content">
                            <h6>
                                {
                                    consumer
                                    ?
                                        consumer.language === 'english'
                                        ?
                                            'Instagram'
                                        :
                                            'ইনস্টাগ্রাম'
                                    :
                                        'ইনস্টাগ্রাম'
                                }
                            </h6>
                            <a href={links.find(l => l.name === 'instagram').link}>{links.find(l => l.name === 'instagram').link}</a>
                        </div>
                    </div>
                }

                {links?.find(l => l.name === 'youtube') &&
                    <div className="list_item">
                        <div className="icon">
                            <RiYoutubeLine />
                        </div>
                        <div className="content">
                            <h6>
                                {
                                    consumer
                                    ?
                                        consumer.language === 'english'
                                        ?
                                            'Youtube'
                                        :
                                            'ইউটিউব'
                                    :
                                        'ইউটিউব'
                                }
                            </h6>
                            <a href={links.find(l => l.name === 'youtube').link}>{links.find(l => l.name === 'youtube').link}</a>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default OrganizationContacts